<template>
    <div class="dus-container pt-lg-80 pb-lg-80 pb-64 pt-40 bg-black c-white cp-universe">
         <h2 class="mb-lg-56 mb-40">{{ $t('home.universe.title')}}</h2>

        <div class="universe-container swiper-container">
            <div class="swiper-wrapper">
                <a :href="item.link" class="universe swiper-slide" v-for="item in list" :key="item.id" v-if="typeof item == 'object'" :style="`background-image: url(${item.image_url})`" target="_blank">
                    <div class="content">
                        <h3 class="title">
                            {{ item.title }}
                        </h3>
                        <RenaultButton is-anchor is-small is-white :href="item.link" v-if="isMobile" class="button"> 
                            <svg class="icon-plus" >
                                <use xlink:href="#icon-plus"></use>
                            </svg>
                        </RenaultButton>
                        <RenaultButton is-anchor is-small is-white :href="item.link" v-else class="button"> 
                            {{item.cta_text}}
                        </RenaultButton>
                    </div>
                </a>
                
            </div>
        </div>

        <div class="universe-navigation d-flex gap-16">
            <div class="button-prev universe-button-prev">
                <svg class="icon-navigation" >
                    <use xlink:href="#icon-navigation-prev"></use>
                </svg>
            </div>
            <div class="button-next universe-button-next">
                <svg class="icon-navigation" >
                    <use xlink:href="#icon-navigation-next"></use>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper, { Navigation } from "swiper";

import RenaultButton from "../Shared/RenaultButton.vue";
Swiper.use([Navigation]);
export default {
    components: {
        RenaultButton,
    },
    data() {
        return {
            list: window.data.about_links,
            swiper: null,
        };
    },
    computed: {
        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },
    },
    mounted() {
        this.swiper = new Swiper(".universe-container", {
            slideClass: "universe",
            slidesPerView: 1.15,
            slidesPerGroup: 1,
            spaceBetween: 24,
            enabled: true,
            navigation: {
                nextEl: ".universe-button-next",
                prevEl: ".universe-button-prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.5,
                },
            },
        });
    },
};
</script>